module.exports = __webpack_public_path__ + "static/img/服务号.cfaa3e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/服务号.jpg
// module id = 113
// module chunks = 99